/**
 * Matches LaunchDarkly `soft-brands` segment (compsets flag off): @slh / @preferred emails.
 */
export default function isSoftBrandUser(email = '') {
  const normalized = email.toLowerCase();
  return /@slh(?:\.|$)/.test(normalized) || /@preferred/.test(normalized);
}
